import { type RouteRecordRaw } from 'vue-router'
import {ROUTES} from '@myorg/type-lib'
import {DataDeletionPage} from '@myorg/account-lib'

export const deleteRoute: RouteRecordRaw = {
    path: ROUTES.ACCOUNT_DELETE.PATH,
    name: ROUTES.ACCOUNT_DELETE.NAME,
    component: DataDeletionPage,
}